<template>
  <v-dialog v-model="dialog" width="600" persistent scrollable>
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>

    <v-card>
      <!-- Step 1: ricerca prodotto -->
      <template v-if="!prodotto_sel">
        <v-text-field
          ref="searchField"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          color="grey"
          filled
          placeholder="Cerca prodotto..."
          hide-details
        >
          <template v-slot:append>
            <v-btn outlined class="mt-n1" color="grey" @click="chiudi">
              Esc
            </v-btn>
          </template>
        </v-text-field>

        <v-card-text class="mt-n2">
          <template v-if="!prodotti_filtrati.length">
            <v-row justify="center" class="mt-8">
              <v-icon size="100" color="grey"
                >mdi-clipboard-text-search-outline</v-icon
              >
            </v-row>
            <v-row justify="center" class="mt-4 mb-2">
              <span class="grey--text">I risultati appariranno qua</span>
            </v-row>
          </template>
          <template v-else>
            <v-card
              flat
              outlined
              v-for="gruppo in prodotti_per_diametro"
              :key="gruppo.diametro"
              class="my-4"
            >
              <v-card-title>
                <span style="font-size: 15px"
                  >Vaso Ø {{ gruppo.diametro }}</span
                >
              </v-card-title>
              <v-card-text>
                <v-list class="mt-n4 ml-n4">
                  <NuovoProdottoRicerca
                    v-for="prodotto in gruppo.elementi"
                    :key="prodotto.id"
                    :prodotto="prodotto"
                    @selezionato="seleziona_prodotto_by_id"
                  />
                </v-list>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </template>

      <!-- Step 2: selezione colori e quantità -->
      <template v-else>
        <v-card-title class="grey--text text-subtitle-1">
          <v-btn icon small class="mr-2" @click="prodotto_sel = null">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          Quantità e Colori
          <v-spacer />
          <v-btn icon @click="chiudi"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-1">
            <v-col cols="12">
              <span style="font-size: 20px"> {{ nome[0] }}</span>
              <br />
              <span style="font-size: 12px"> {{ nome[1] }}</span>
            </v-col>
          </v-row>
          <!-- Con specie: raggruppato per serie -->
          <template v-if="prodotto_sel.specie">
            <div
              v-for="serie in colori_per_serie"
              :key="serie.nome_serie || 'no-serie'"
            >
              <div v-if="serie.nome_serie" class="caption grey--text mt-2 mb-1">
                {{ serie.nome_serie }}
              </div>
              <v-row no-gutters class="flex-wrap mb-2">
                <v-menu
                  v-for="colore in serie.colori"
                  :key="colore.id"
                  offset-y
                  bottom
                  max-width="200"
                  :close-on-content-click="false"
                  @input="(v) => on_menu_open(v, colore.id)"
                >
                  <template v-slot:activator="{ on: men_u }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tip }">
                        <v-badge
                          color="green"
                          :value="colore._qta > 0"
                          :content="colore._qta"
                          overlap
                          bordered
                          offset-x="20"
                          offset-y="20"
                        >
                          <v-avatar
                            v-on="{ ...tip, ...men_u }"
                            style="cursor: pointer"
                            class="mr-2 mb-2"
                            size="70"
                          >
                            <v-img :src="color_img(colore)" :alt="colore.nome">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    :width="2"
                                    color="primary"
                                  />
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </v-badge>
                      </template>
                      <span class="text-capitalize">{{ colore.nome }}</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-text class="mt-n2">
                      <v-row no-gutters class="primary--text"
                        >{{ colore.nome }}<v-spacer
                      /></v-row>
                      <v-row no-gutters style="font-size: 12px" class="mb-2"
                        >Specifica quantità:</v-row
                      >
                      <v-text-field
                        :ref="'qty_' + colore.id"
                        v-model.number="colore._qta"
                        maxlength="3"
                        dense
                        hide-details
                        outlined
                        prepend-icon="mdi-minus"
                        append-outer-icon="mdi-plus"
                        @click:prepend="colore._qta > 0 ? colore._qta-- : null"
                        @click:append-outer="colore._qta++"
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-row>
            </div>
          </template>

          <!-- Senza specie: flat -->
          <v-row v-else no-gutters class="flex-wrap">
            <v-menu
              v-for="colore in colori"
              :key="colore.id"
              offset-y
              bottom
              max-width="200"
              :close-on-content-click="false"
              @input="(v) => on_menu_open(v, colore.id)"
            >
              <template v-slot:activator="{ on: men_u }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tip }">
                    <v-badge
                      color="green"
                      :value="colore._qta > 0"
                      :content="colore._qta"
                      overlap
                      bordered
                      offset-x="20"
                      offset-y="20"
                    >
                      <v-avatar
                        v-on="{ ...tip, ...men_u }"
                        style="cursor: pointer"
                        class="mr-2 mb-2"
                        size="70"
                      >
                        <v-img :src="color_img(colore)" :alt="colore.nome">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                :width="2"
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-badge>
                  </template>
                  <span class="text-capitalize">{{ colore.nome }}</span>
                </v-tooltip>
              </template>
              <v-card>
                <v-card-text class="mt-n2">
                  <v-row no-gutters class="primary--text"
                    >{{ colore.nome }}<v-spacer
                  /></v-row>
                  <div v-if="colore.nome_serie" class="caption grey--text mb-1">
                    {{ colore.nome_serie }}
                  </div>
                  <v-row no-gutters style="font-size: 12px" class="mb-2"
                    >Specifica quantità:</v-row
                  >
                  <v-text-field
                    :ref="'qty_' + colore.id"
                    v-model.number="colore._qta"
                    maxlength="3"
                    dense
                    hide-details
                    outlined
                    prepend-icon="mdi-minus"
                    append-outer-icon="mdi-plus"
                    @click:prepend="colore._qta > 0 ? colore._qta-- : null"
                    @click:append-outer="colore._qta++"
                  />
                </v-card-text>
              </v-card>
            </v-menu>
          </v-row>

          <v-text-field
            v-model="commento"
            label="Note articolo"
            outlined
            dense
            hide-details
            class="mt-4"
          />

          <v-alert v-if="error" type="error" dense text class="mt-3">
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="loading" @click="chiudi">Annulla</v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="!ha_colori_selezionati"
            @click="salva"
          >
            Salva
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import NuovoProdottoRicerca from "@/components/Ordini/desktop/crea_nuovo_ordine/NuovoProdottoRicerca.vue";

export default {
  name: "PrenotazioneAggiungiProdotto",

  components: { NuovoProdottoRicerca },

  props: {
    idPrenotazione: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
      search: "",
      prodotto_sel: null,
      colori: [],
      commento: "",
      loading: false,
      error: null,
    };
  },

  computed: {
    prodotti_filtrati() {
      if (this.search.length < 3) return [];
      const q = this.search.toLowerCase();
      return this.$store.getters.get_lista_prodotti_raw.filter(
        (p) =>
          p.nome.toLowerCase().includes(q) || p.cod?.toLowerCase().includes(q)
      );
    },
    nome() {
      return this.prodotto_sel.nome.split(" in ");
    },

    prodotti_per_diametro() {
      const map = {};
      this.prodotti_filtrati.forEach((p) => {
        if (!map[p.diametro]) map[p.diametro] = [];
        map[p.diametro].push(p);
      });
      return Object.keys(map).map((d) => ({
        diametro: parseInt(d),
        elementi: map[d],
      }));
    },

    ha_colori_selezionati() {
      return this.colori.some((c) => c._qta > 0);
    },

    colori_per_serie() {
      const map = {};
      this.colori.forEach((c) => {
        const key = c._nome_serie || "";
        if (!map[key]) map[key] = { nome_serie: key, colori: [] };
        map[key].colori.push(c);
      });
      return Object.values(map).sort((a, b) => {
        if (!a.nome_serie) return -1;
        if (!b.nome_serie) return 1;
        return a.nome_serie.localeCompare(b.nome_serie);
      });
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => this.$refs.searchField?.$el?.querySelector("input")?.focus());
      }
    },
  },

  methods: {
    async seleziona_prodotto_by_id(id) {
      const prodotto = this.$store.getters.get_lista_prodotti_raw.find(
        (p) => p.id === id
      );
      if (!prodotto) return;
      this.prodotto_sel = prodotto;
      if (prodotto.specie) {
        const specie = this.$store.getters.get_specie_by_id(prodotto.specie);
        if (!specie) return;
        const colori_specie = await this.$store.dispatch(
          "fetch_colori_by_id",
          specie.colori
        );
        this.colori = colori_specie
          .filter(
            (c) =>
              prodotto.series?.includes(c.id_series?.[0]) ||
              (prodotto.series?.includes("000000") &&
                (!c.id_series || c.id_series.length === 0))
          )
          .map((c) => {
            const id_s = c.id_series?.[0] ?? null;
            const serie_obj = id_s
              ? specie.series.find((s) => s.id === id_s)
              : null;
            return { ...c, _qta: 0, _nome_serie: serie_obj?.nome ?? "" };
          });
      } else {
        this.colori = (prodotto.colori ?? []).map((c) => ({ ...c, _qta: 0 }));
      }
    },

    async salva() {
      this.loading = true;
      this.error = null;
      try {
        const colori_da_salvare = this.colori.filter((c) => c._qta > 0);
        for (const colore of colori_da_salvare) {
          await this.$store.dispatch("prenotazioni/aggiorna_colore", {
            id: this.idPrenotazione,
            id_prodotto: this.prodotto_sel.id,
            id_colore: colore.id,
            qta: colore._qta,
            nome_serie: colore._nome_serie ?? colore.nome_serie ?? "",
          });
        }
        if (this.commento) {
          await this.$store.dispatch("prenotazioni/aggiorna_commento_articolo", {
            id: this.idPrenotazione,
            id_prodotto: this.prodotto_sel.id,
            commento: this.commento,
          });
        }
        this.$emit("aggiornata");
        this.chiudi();
      } catch {
        this.error = "Errore durante il salvataggio. Riprova.";
      } finally {
        this.loading = false;
      }
    },

    on_menu_open(opened, colore_id) {
      if (!opened) return;
      setTimeout(() => {
        const ref = this.$refs["qty_" + colore_id];
        const field = Array.isArray(ref) ? ref[0] : ref;
        const input = field?.$el?.querySelector("input");
        if (input) {
          input.focus();
          input.select();
        }
      }, 100);
    },

    color_img(colore) {
      if (this.prodotto_sel?.specie) {
        return process.env.VUE_APP_API_ROOT + "/specie/img_colore/" + colore.id;
      }
      return (
        process.env.VUE_APP_API_ROOT +
        "/prodotto/" +
        this.prodotto_sel.id +
        "/img_colore/" +
        colore.id
      );
    },

    chiudi() {
      this.dialog = false;
      this.search = "";
      this.prodotto_sel = null;
      this.colori = [];
      this.commento = "";
      this.error = null;
    },
  },
};
</script>
